module.exports = __webpack_public_path__ + "static/media/grid-metal.d23075a4.png";